import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from '../api/axios';
import { useAuth } from './AuthContext';

interface NotificationsContextType {
  notificationCount: number;
  refreshNotificationCount: () => Promise<void>;
}

const NotificationsContext = createContext<NotificationsContextType | undefined>(undefined);

export const NotificationsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [notificationCount, setNotificationCount] = useState(0);

  const refreshNotificationCount = async () => {
    if (!isAuthenticated) {
      setNotificationCount(0);
      return;
    }

    try {
      const response = await axios.get('/notifications/count');
      setNotificationCount(response.data as number);
    } catch {
      setNotificationCount(0);
    }
  };

  useEffect(() => {
    const sync = async () => {
      if (!isAuthenticated) {
        setNotificationCount(0);
        return;
      }

      try {
        const response = await axios.get('/notifications/count');
        setNotificationCount(response.data as number);
      } catch {
        setNotificationCount(0);
      }
    };

    void sync();
  }, [isAuthenticated]);

  return (
    <NotificationsContext.Provider
      value={{
        notificationCount,
        refreshNotificationCount,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationsContext);

  if (!context) {
    throw new Error('useNotifications must be used within NotificationsProvider');
  }

  return context;
};
